import isNullish from '@/core/lib/utils/isNullish/isNullish';

export default isNullish;
